let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dwAxe")).then(() => parcelRequire('9Cwwc'));